import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition, MatSnackBar } from '@angular/material/snack-bar';
import { PlantService } from '../plant.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatInput, MatHint, MatError } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-plant-manager',
    templateUrl: './plant-manager.component.html',
    styleUrls: ['./plant-manager.component.css'],
    imports: [NgIf, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatHint, MatError, MatCheckbox, MatButton, RouterLink]
})
export class PlantManagerComponent implements OnInit {
  formGroup: UntypedFormGroup;
  id: number;
  type: boolean = true;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  constructor(private formBuilder: UntypedFormBuilder,
    public plantService: PlantService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute) {

    //Initialize form
    this.formGroup = this.formBuilder.group({
      id: [],
      name: [],
      display_name: [],
      display_order: [],
      Environment: [],
      time_zone: [],
      Site: [],
      auto_create: [],
      Type: [],
    });

  }

  ngOnInit() {
    this.route.data.subscribe(v => {
      if (v.type == 'create') {
        this.type = true;
        this.plantService.selectedPlant = null;
      } else {
        this.type = false;
      }
    });
    //set selected line
    if (this.plantService.selectedPlant != undefined) {
      this.formGroup.patchValue(this.plantService.selectedPlant);
      this.plantService.selectedPlant = null;
    }
  }

  onFormSubmit(form: UntypedFormGroup) {
    /*if (form.value.id == null)
      this.insertRecord(form);
    else
      this.updateRecord(form);*/
  }

  insertRecord(form: UntypedFormGroup) {
    this.plantService.postPlant(form.value).subscribe(res => {
      this._snackBar.open("Record creation Success", "", {
        duration: 5000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        panelClass: ['alert-success'],
      });
      this.type = false;
    });
  }

  updateRecord(form: UntypedFormGroup) {
    this.plantService.putPlant(form.value).subscribe(res => {
      console.log(res);
      this._snackBar.open("Record Updation Success", "", {
        duration: 5000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        panelClass: ['alert-success'],
      });
      this.plantService.refreshList();
    });
  }



}
